import { YaysonPresenter } from './../../../model-repository'

const TYPE = 'exam-reports'

export class ExamReportPresenter extends YaysonPresenter {

  public type: string = TYPE

  public attributes(modelData) {
    return {}
    // TODO Implement this code once needed
    // return {
    //   'json-property-name': modelData['model-property-name']
    // }
  }

  public relationships() {
    return {}
    // TODO Implement this code once needed
    // return {
    //   'json-relation-name': PresenterClass
    // }
  }
}

ExamReportPresenter.prototype.type = TYPE



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/presenters/exam-report/exam-report.presenter.ts